/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/
import { api } from "../api";
import { jwtDecode } from "jwt-decode";

export async function uploadLpo(entry) {
  const token = localStorage.getItem("lpo_token");
  if (!token) throw new Error("Missing auth token");

  const decoded = jwtDecode(token);
  const lpo_id = decoded?.lpo_id || decoded?.sub;
  if (!lpo_id) throw new Error("Invalid token: missing lpo_id");

  // Rehydrate blobs
  const voiceBlob = entry.voiceBlob instanceof Blob
    ? entry.voiceBlob
    : new Blob([entry.voiceBlob?.data], { type: entry.voiceBlob?.type || "audio/webm" });

  const form = new FormData();
  form.append("voice_file", voiceBlob, "voice.webm");
  form.append("lpo_id", lpo_id);

  // Append photos if present
  if (entry.photoBlobs && Array.isArray(entry.photoBlobs)) {
    entry.photoBlobs.forEach((photo, idx) => {
      const rehydrated = photo instanceof Blob
        ? photo
        : new Blob([photo?.data], { type: photo?.type || "image/jpeg" });
      form.append(`photos`, rehydrated, `photo_${idx}.jpg`);
    });
  }

  const res = await api.post("/upload-voice", form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (res.status !== 200) {
    throw new Error("Voice/photo upload failed");
  }

  return res.data;
}